import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ palette, spacing, breakpoints }) => ({
  logoImage: {
    left: spacing(9),
    position: 'absolute',
    width: 'auto',
    height: '100%',
    objectFit: 'contain',
    top: spacing(0.25),
    padding: spacing(1),
    [breakpoints.down('sm')]: {
      left: spacing(0),
      width: spacing(18.75),
    },
    [breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  container: {
    width: '100%',
    height: spacing(11),
    position: 'relative',
    backgroundColor: palette.white.main,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: ` ${spacing(0, 0.1, 1, 0)}  ${palette.scorpionGray.main}`,
  },
  supportContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Open Sans',
    fontWeight: spacing(87.5),
    fontSize: spacing(2.5),
    lineHeight: '27.24px',
    paddingRight: spacing(4),
    cursor: 'pointer',
    [breakpoints.down('sm')]: {
      paddingRight: spacing(2),
    },
  },
  congratsTitle: {
    fontSize: spacing(3.125),
    fontWeight: spacing(100),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    color: '#623293',
    marginBottom: '25px',
    [breakpoints.down('sm')]: {
      fontSize: spacing(2.375),
    },
    '@media (max-width:375px)': {
      fontSize: spacing(2.25),
    },
    '@media (max-width:320px)': {
      fontSize: spacing(2.25),
    },
  },
  logoContainer: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
